import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
export const globalfunc = {
  timeSince: (date) => {
    let secFormat = distanceInWordsStrict(new Date(), date, {unit: 's'})
    let seconds = parseInt(secFormat.replace(/ seconds/g, ""))
    var intervalType;

    var interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
      intervalType = 'year';
    } else {
      interval = Math.floor(seconds / 2592000);
      if (interval >= 1) {
        intervalType = 'month';
      } else {
        interval = Math.floor(seconds / 86400);
        if (interval >= 1) {
          intervalType = 'day';
        } else {
          interval = Math.floor(seconds / 3600);
          if (interval >= 1) {
            intervalType = "hour";
          } else {
            interval = Math.floor(seconds / 60);
            if (interval >= 1) {
              intervalType = "min";
            } else {
              interval = seconds;
              intervalType = "second";
            }
          }
        }
      }
    }

    if (interval > 1 || interval === 0) {
      intervalType += 's';
    }

    return interval + ' ' + intervalType + ' ago';
  },
  getTeamOfParent: (parent, teams) => {
    for (const i in parent) {
      teams[parent[i]["team_id"]] = true;
      if (parent[i]["parent"]) {
        teams = globalfunc.getTeamOfParent(parent[i]["parent"], teams);
      }
    }
    return teams;
  },
  generateToken: (length) => {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * charactersLength)
      );
    }
    return result;
  },
  round: (value, decimals) => {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  },
  ordinal_suffix_of: (i) => {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
  },
  getAllParent: (teams, key) => {
    const organization = [];
    for(let x in teams[key]){
      
      if(teams[teams[key][x].team_id] !== undefined){
        organization.push({team_id: teams[key][x].team_id, parent: globalfunc.getAllParent(teams, teams[key][x].team_id)});
      }else{
        organization.push({team_id: teams[key][x].team_id});
      }
    }
    return organization;
  },
  generateRandomNumber() {
    const min = 1;
    const max = 999999999;
  
    let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    let formattedNumber = randomNumber.toFixed(0).padStart(9, '0');
  
    return formattedNumber;
  },
  truncateText: (text, maxLength) => {
    let length = maxLength;
    return text.length > length ? text.slice(0, length) + "..." : text;
  },
  addCommasInNumber: (value, decimal) => {
    let num = Number(value).toFixed(decimal);
    let str = num.toString().split(".");
    if (str[0].length >= 4) {
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    return `${str[0]}.${str[1]}`;
  },
  calculateStartDate: (year,month,startDay) => {
    let cycleStart = new Date(`${year}-${month}-${startDay}`);
    cycleStart.setMonth(cycleStart.getMonth() - 1);
    cycleStart.setDate(cycleStart.getDate() + 1);
    return cycleStart;
  },
  // calculateEndDate: (startDay) => {
  //   const today = new Date();
  //   let cycleStart = new Date(today.getFullYear(), today.getMonth(), startDay);
  //   if (today.getDate() < startDay) {
  //     cycleStart.setMonth(cycleStart.getMonth() - 1);
  //   }
  //   cycleStart.setMonth(cycleStart.getMonth() + 1);
  //   cycleStart.setDate(cycleStart.getDate() - 1);
  //   return cycleStart;
  // }
  calculatePercentile: (arr, percentile) => {
    // Sort array in ascending order
    const sorted = arr.filter(val => val !== null && val !== undefined && !isNaN(val)).sort((a, b) => a - b);
    
    if (sorted.length === 0) return 0;
    if (sorted.length === 1) return sorted[0];
    
    // Calculate the index for the percentile
    const index = (percentile / 100) * (sorted.length - 1);
    const lower = Math.floor(index);
    const upper = Math.ceil(index);
    const weight = index % 1;
    
    // If the index is an integer, return the value at that index
    if (lower === upper) {
      return sorted[index];
    }
    
    // Otherwise, interpolate between the two nearest values
    return sorted[lower] * (1 - weight) + sorted[upper] * weight;
  },
  /**
   * Unified Culture Index score calculation that dispatches to the correct
   * method based on question type (Scale 0-10 vs Multiple Choice with feelings).
   * Returns {dataSum, total} so that (dataSum/total)*100 = 0-100 score.
   */
  calculateCultureScore: function(questionMasterArr, questId, answers) {
    const questionData = questionMasterArr ? questionMasterArr[questId] : null;
    const isScale = questionData && questionData.type === 'Scale';
    if (isScale) {
      return this.calculateScaleScore(answers);
    }
    return this.calculateFeelingScore(questionMasterArr, questId, answers);
  },
  /**
   * Calculate feeling-based score for Culture Index Custom
   * Formula: Culture Index = (Positive × 100 + Neutral × 50 + Negative × 0) / Total
   * 
   * @param questionMasterArr - Master array containing question data with feeling info
   * @param questId - Question ID to look up
   * @param answers - Object with answer keys and their counts { answerKey: count }
   * @returns { dataSum: number, total: number } - Returns normalized dataSum and total for percentage calculation
   */
  calculateFeelingScore: function(questionMasterArr, questId, answers) {
    let dataSum = 0;
    let total = 0;
    
    for (const answer in answers) {
      if (answers.hasOwnProperty(answer)) {
        let feeling = '';
        if (questionMasterArr[questId] && 
            questionMasterArr[questId]['m_choice'] && 
            questionMasterArr[questId]['m_choice'].feeling && 
            questionMasterArr[questId]['m_choice'].feeling[answer]) {
          feeling = questionMasterArr[questId]['m_choice'].feeling[answer];
        }
        const count = answers[answer];
        
        if (feeling === 'Positive') {
          dataSum += count; // 100/100 = 1
        } else if (feeling === 'Neutral') {
          dataSum += count * 0.5; // 50/100 = 0.5
        }
        // Negative adds 0, so no need to add
        
        total += count;
      }
    }
    
    return { dataSum, total };
  },
  /**
   * Calculate score for Scale (0-10) questions used in Culture Index
   * Normalizes to the same {dataSum, total} contract as calculateFeelingScore
   * so that (dataSum / total) * 100 yields a 0-100 percentage.
   *
   * @param answers - Object with score keys (0-10) and their counts { "0": count, "1": count, ..., "10": count }
   * @returns { dataSum: number, total: number }
   */
  calculateScaleScore: function(answers) {
    let dataSum = 0;
    let total = 0;

    for (const key in answers) {
      if (answers.hasOwnProperty(key)) {
        const score = Number(key);
        const count = Number(answers[key]);
        if (!isNaN(score) && !isNaN(count) && count > 0) {
          dataSum += count * (score / 10);
          total += count;
        }
      }
    }

    return { dataSum, total };
  }
}